import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const usePromoDiscountHook = (
    lineItem: ILineItem,
    frequency: 'monthly' | 'dueToday'
): ICostSummaryItem | undefined => {
    if (lineItem.promoSummary?.hasPromo) {
        const item: ICostSummaryItem = {
            lineNumber: lineItem.lineNumber,
            itemName: lineItem.promoSummary.promoResponse.promo.name,
            amount: 0,
            type: 'discount'
        };

        if (frequency === 'monthly') {
            item.amount = lineItem.promoSummary?.dueMonthly;
        } else {
            item.amount = lineItem.promoSummary?.dueToday;
        }

        return item;
    }
};
